// extracted by mini-css-extract-plugin
module.exports = {"cart-icon-indicator":"cartIcon-module--cart-icon-indicator--2KBhN","expanded":"cartIcon-module--expanded--4VIBk"};